<ng-container *ngFor="let item of transformItems; trackBy: trackByValue">
  <button
    mat-menu-item
    (click)="setTransform(item.transform)"
    [attr.data-test]="'bar-options-menu-transform-' + item.transform"
  >
    <capra-icon
      class="menu-dot-indicator"
      [style.visibility]="item.transform === transform ? 'visible' : 'hidden'"
      icon="icon-dot-indicator"
    >
    </capra-icon>
    {{ item.label }}
  </button>
</ng-container>
<ng-container *ngIf="isShowStackSumAllowed">
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="setShowStackSum(false)" data-test="bar-options-menu-label-bar-sections">
    <capra-icon
      class="menu-dot-indicator"
      [style.visibility]="!isShowStackSum ? 'visible' : 'hidden'"
      icon="icon-dot-indicator"
    >
    </capra-icon>
    Label bar sections
  </button>
  <button mat-menu-item (click)="setShowStackSum(true)" data-test="bar-options-menu-label-bar-totals">
    <capra-icon
      class="menu-dot-indicator"
      [style.visibility]="isShowStackSum ? 'visible' : 'hidden'"
      icon="icon-dot-indicator"
    >
    </capra-icon>
    Label bar totals
  </button>
</ng-container>
